import * as Sentry from '@sentry/react-native'
import getEnvironment from 'app/environment'
import Constants from 'expo-constants'
import * as Device from 'expo-device'
import * as Updates from 'expo-updates'

const { name } = getEnvironment()

// Construct release name following Sentry's recommended format
const RELEASE_NAME = Constants.expoConfig?.version
  ? `com.nextforce.app@${Constants.expoConfig.version}`
  : undefined

Sentry.setExtras({
  manifest: Updates.manifest,
  deviceYearClass: Device.deviceYearClass,
  linkingUri: Constants.linkingUri,
})

Sentry.setTag('expoChannel', Updates.channel ?? 'N/A')
Sentry.setTag('appVersion', Constants.expoConfig?.version)
Sentry.setTag('expoSdkVersion', Constants.expoConfig?.sdkVersion)
Sentry.setTag('deviceId', Constants.sessionId)
Sentry.setTag('appOwnership', Constants.appOwnership ?? 'N/A')

if (Constants.appOwnership === 'expo' && Constants.expoVersion) {
  Sentry.setTag('expoAppVersion', Constants.expoVersion)
}

// Create routing instrumentation first
export const routingInstrumentation = Sentry.reactNavigationIntegration()

// Determine if performance and release health should be enabled
const performanceAndReleaseHealthEnabled = name === 'production'

export function startSentry() {
  Sentry.init({
    dsn: 'https://608f15a5a54c4436a8e5b09be6c83bf4@o880522.ingest.sentry.io/5939520',

    // Release configuration
    release: RELEASE_NAME,
    dist: Constants.expoConfig?.version,
    environment: name,

    // Development settings
    debug: false,
    enabled: !__DEV__, // Enable in all environments except local dev

    // Performance monitoring
    tracesSampleRate: performanceAndReleaseHealthEnabled ? 0.1 : 0,

    // Trace propagation targets for distributed tracing
    tracePropagationTargets: ['localhost', /^https:\/\//, /^http:\/\//],

    // Tracing options moved to Sentry.init in v6
    enableNativeFramesTracking: performanceAndReleaseHealthEnabled,
    enableStallTracking: performanceAndReleaseHealthEnabled,
    enableUserInteractionTracing: performanceAndReleaseHealthEnabled,
    enableAppStartTracking: performanceAndReleaseHealthEnabled,

    integrations: [
      routingInstrumentation,
      Sentry.reactNativeTracingIntegration({
        idleTimeoutMs: 1000, // renamed from idleTimeout in v6
      }),
    ],

    // Session tracking for release health
    enableAutoSessionTracking: performanceAndReleaseHealthEnabled,
    sessionTrackingIntervalMillis: performanceAndReleaseHealthEnabled
      ? 30000
      : undefined,
  })
}
